<div class="gallery_container">
  <carousel #carousel
    [isAnimated]="true"
    [noPause]="true"
    [interval]="4000"
    *ngIf="galleryList.length !== 0"
    [showIndicators]="true"
    (activeSlideChange)="cambiaSlide()"
  >
    <slide *ngFor="let item of galleryList; let index = index">
      <img
        class="gallery_img"
        [src]="buildUrlGallery(item)"
        alt="galeria"
        *ngIf="typeService(item.urlFile) === 'image' && !item.empresa"
      />

      <div
        class="overlay_video"
        *ngIf="typeService(item.urlFile) === 'video' && !item.empresa"
      >
        <video class="gallery_video" #video>
          <source [src]="buildUrlGallery(item)" type="video/mp4" />
        </video>
        <div class="overlay_video_controls" (click)="playVideo(video)">
          <i class="fas fa-play" *ngIf="!onPlay"></i>
          <i class="fas fa-pause" *ngIf="onPlay"></i>
        </div>
        <!-- <span (click)="toggleMute(video)">sound</span> -->
      </div>

      <!-- Empresa -->
      <img
        class="gallery_img"
        [src]="'https://tarjetasf.virtualplace.online/Empresas/Galeria/' + item.urlFile"
        alt="galeria"
        *ngIf="typeService(item.urlFile) === 'image' && item.empresa"
      />

      <div
        class="overlay_video"
        *ngIf="typeService(item.urlFile) === 'video' && item.empresa"
      >
        <video class="gallery_video" #video>
          <source
            [src]="urlServer + item.urlFile"
            type="video/mp4"
          />
        </video>
        <div class="overlay_video_controls" (click)="playVideo(video)">
          <i class="fas fa-play" *ngIf="!onPlay"></i>
          <i class="fas fa-pause" *ngIf="onPlay"></i>
        </div>
        <!-- <span (click)="toggleMute(video)">sound</span> -->
      </div>
    </slide>
  </carousel>
  <carousel
    [isAnimated]="true"
    [noPause]="true"
    [interval]="4000"
    [showIndicators]="true"
    *ngIf="galleryList.length === 0"
  >
    <slide>
      <img
        src="../../../../../assets/img/carousel1.jpg"
        class="image-gallery"
      />
    </slide>
    <slide>
      <img
        src="../../../../../assets/img/carousel2.jpg"
        class="image-gallery"
      />
    </slide>
    <slide>
      <img
        src="../../../../../assets/img/carousel3.jpg"
        class="image-gallery"
      />
    </slide>
  </carousel>
</div>
